import styles from './PubLoader.module.css';

export const PubLoader = () => {
  return (
    <div className={styles.loader}></div>
  )
}